import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

import { IonicModule } from '@ionic/angular';

import { VendorsHomePage } from './vendors-home.page';

import { PipesModule } from '../../shared/pipes/pipes.module';

import { AnimatedImageComponentModule } from '../../shared/components/animated-image/animated-image.module';
import { AreaDateTimePickerComponentModule } from '../../shared/components/area-date-time-picker/area-date-time-picker.module';
import { BannerAdsComponentModule } from '../../shared/components/banner-ads/banner-ads.module';
import { BrowserFooterComponentModule } from '../../shared/components/browser-footer/browser-footer.module';
import { BrowserHeaderComponentModule } from '../../shared/components/browser-header/browser-header.module';
import { FeaturedCollectionHorizontalListComponentModule } from '../../shared/components/featured-collection-horizontal-list/featured-collection-horizontal-list.module';
import { InfoMessagesComponentModule } from '../../shared/components/info-messages/info-messages.module';
import { LoyaltyProgramStatusComponentModule } from '../../shared/components/loyalty-program-status/loyalty-program-status.module';
import { RouterLinkComponentModule } from '../../shared/components/router-link/router-link.module';
import { VendorItemComponentModule } from '../../shared/components/vendor-item/vendor-item.module';
import { VendorComponentModule } from '../../shared/components/vendor/vendor.module';

import { VendorsHomePageRoutingModule } from './vendors-home-routing.module';

import { SwiperModule } from 'swiper/angular';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    VendorsHomePageRoutingModule,
    FeaturedCollectionHorizontalListComponentModule,
    PipesModule,
    TranslateModule.forChild(),
    AreaDateTimePickerComponentModule,
    AnimatedImageComponentModule,
    InfoMessagesComponentModule,
    VendorComponentModule,
    BannerAdsComponentModule,
    SwiperModule,
    BrowserHeaderComponentModule,
    BrowserFooterComponentModule,
    RouterLinkComponentModule,
    LoyaltyProgramStatusComponentModule,
    VendorItemComponentModule,
  ],
  declarations: [VendorsHomePage],
})
export class VendorsHomePageModule {}
